import { createAction } from '@reduxjs/toolkit';
import { SnackState } from './snackTypes';

export const showSnack = createAction<SnackState>('SNACK/SHOW');
export const hideSnack = createAction<void>('SNACK/HIDE');
